import { RootState } from '../reducers'

export const ExternalLinksSelector = (state: RootState, id: string) => (state.externalLinks.pages && state.externalLinks.pages[id] ? state.externalLinks.pages[id].content : [])

export const lastPageSelector = (state: RootState, id: string) => (state.externalLinks.pages && state.externalLinks.pages[id] ? state.externalLinks.pages[id].last : null)

export const externalLinksPagingSelector = (state: RootState, id: string) => (state.externalLinks.pages && state.externalLinks.pages[id] ? state.externalLinks.pages[id] : null)
